import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Modal, FormGroup, Alert } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import CargomaticInput from 'components/v2/input';
import { isEmpty } from 'lodash';
import LoadingCircle from 'components/ui/LoadingCircle';

const hasOwnProperty = Object.prototype.hasOwnProperty;

class AddDriverModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: '',
      last_name: '',
      username: '',
      email: '',
      password: '',
      cdl_number: '',
      confirmation: '',
      receive_offers: false,
      errors: {
        first_name: {},
        last_name: {},
        phone: {},
        password: {},
        cdl: {},
        confirmation: {},
        email: {},
      },
    };
  }
  onChange(key, value) {
    this.setState({ [key]: value });
  }

  onCheckboxChange(key, checked) {
    this.setState({ [key]: checked });
  }

  onSave = () => {
    this.setState({ saving: true }, () => this.props.onSave(this.getFields()));
  };

  getFields() {
    return { ...this.state };
  }

  renderSuccessMessage() {
    const { t } = this.props;
    if (this.props.formState.isSuccess) {
      return (
        <Alert bsStyle="success">
          <p>{t('DRIVER_ADDED_SUCCESS')}</p>
        </Alert>
      );
    }
    return null;
  }

  renderErrorMessage() {
    const { t } = this.props;
    if (
      !isEmpty(this.props.formState.error) &&
      this.props.formState.error.status
    ) {
      const {
        formState: {
          error: { status },
        },
      } = this.props;
      return (
        <Alert bsStyle="danger">
          <p>{t(status)}</p>
        </Alert>
      );
    }
  }

  renderError(field) {
    const { t } = this.props;
    const {
      formState: { error },
    } = this.props;

    if (!error || !error[field]) {
      return {};
    }
    return new Error(t(error[field]));
  }

  render() {
    const { errors } = this.state;
    const { t } = this.props;
    return (
      <Modal show={this.props.formState.show} onHide={this.props.onHide} enforceFocus={false}>
        <Modal.Header>
          <h3 className="text-grey-darkest">{t('ADD_A_DRIVER')}</h3>
        </Modal.Header>
        <Modal.Body>
          {this.renderSuccessMessage()}
          {this.renderErrorMessage()}
          <Row>
            <Col md={6}>
              <div className="space-y-8">
                <CargomaticInput
                  info={t('DRIVERS_FIRST_NAME')}
                  error={this.renderError('first_name')}
                  label={t('FIRST_NAME')}
                  onChange={(value) => this.onChange('first_name', value)}
                  placeholder={t('FIRST_NAME')}
                  type="text"
                  value={this.state.first_name}
                />
                <CargomaticInput
                  info={t('DRIVERS_LAST_NAME')}
                  error={this.renderError('last_name')}
                  label={t('LAST_NAME')}
                  onChange={(value) => this.onChange('last_name', value)}
                  placeholder={t('LAST_NAME')}
                  type="text"
                  value={this.state.last_name}
                />
                <CargomaticInput
                  info={t('DRIVERS_CDL_NUMBER')}
                  error={this.renderError('cdl_number')}
                  label={t('COMMERCIAL_DRIVER_LICENSE')}
                  placeholder={t('COMMERCIAL_DRIVER_LICENSE')}
                  onChange={(value) => this.onChange('cdl_number', value)}
                  type="text"
                  value={this.state.cdl_number}
                />
                <CargomaticInput
                  info={t('DRIVERS_EMAIL_ADDRESS')}
                  error={this.renderError('email')}
                  label={t('EMAIL_ADDRESS')}
                  onChange={(value) => this.onChange('email', value)}
                  placeholder={t('EMAIL')}
                  type="text"
                  value={this.state.email}
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="space-y-8">
                <CargomaticInput
                  info={t('DRIVERS_USERNAME_LOGIN_MOBILE_APP')}
                  error={this.renderError('username')}
                  label={t('USER_NAME')}
                  onChange={(value) => this.onChange('username', value)}
                  placeholder={t('USER_NAME')}
                  type="text"
                  value={this.state.username}
                />
                <CargomaticInput
                  info={t('DRIVERS_PHONE_NUMBER')}
                  label={t('PHONE_NUMBER')}
                  error={this.renderError('phone')}
                  onChange={(value) => this.onChange('phone', value)}
                  placeholder={t('PHONE_NUMBER')}
                  type="text"
                  value={this.state.phone}
                />
                <CargomaticInput
                  info={t('DRIVERS_PWD_LOGIN_MOBILE_APP')}
                  label={t('PASSWORD')}
                  error={this.renderError('password')}
                  onChange={(value) => this.onChange('password', value)}
                  placeholder={t('PASSWORD')}
                  type="password"
                  value={this.state.password}
                />
                <CargomaticInput
                  info={t('DRIVERS_PWD_LOGIN_MOBILE_APP')}
                  label={t('CONFIRM_PASSWORD')}
                  onChange={(value) => this.onChange('confirmation', value)}
                  placeholder={t('CONFIRM_PASSWORD')}
                  type="password"
                  error={this.renderError('password')}
                  value={this.state.confirmation}
                />
                <CargomaticInput
                  info={t('AUTO_SEND_DRIVERS_OFFERS_TO_MARKET')}
                  label={t('RECEIVE_OFFERS')}
                  onChange={(checked) =>
                    this.onCheckboxChange('receive_offers', checked)
                  }
                  type="checkbox"
                  value={this.state.receive_offers}
                />
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="button button-secondary"
            onClick={() => this.props.onHide()}
          >
            {titleize(t('CLOSE'))}
          </button>
          <button
            disabled={this.props.savingDriver}
            className="button button-green"
            onClick={this.onSave}
          >
            {!this.props.savingDriver && t('ADD_DRIVER')}
            {this.props.savingDriver && (
              <LoadingCircle text={`${t('SAVING')}...`} />
            )}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

AddDriverModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  formState: PropTypes.shape({
    show: PropTypes.bool.isRequired,
    error: PropTypes.object.isRequired,
    isSuccess: PropTypes.bool.isRequired,
    savingDriver: PropTypes.bool.isRequired,
  }),
};

AddDriverModal.defaultProps = {
  formState: {
    show: false,
    error: {},
    success: false,
  },
};
export default withTranslation()(AddDriverModal);
